import React from "react";
import { useState, useEffect } from "react";
import {Link} from "react-router-dom"
import Title from "../assets/texts/h1-desktop";
import Text from "../assets/texts/body-desktop";
import Button from "../assets/buttons/btnPrimary";
import TitleCard from "../assets/texts/titleCard-mobile";
import ImgAboutUsOne from "../assets/images/320px/320_about_1.png";
import ImgAboutUsTwo from "../assets/images/320px/320_about_2.png";
import ImgAboutUsThree from "../assets/images/320px/320_about_3.png";
/*  */
import ImgTeamDavid320 from "../assets/images/320px/320_david_ding.png";
import ImgTeamUriel320 from "../assets/images/320px/320_uriel_natero.png";
import ImgTeamHumberto320 from "../assets/images/320px/320_humberto_bertazza.png";
import ImgTeamAlejandroO320 from "../assets/images/320px/320_alejandro_ottero.png";
import ImgTeamMaria320 from "../assets/images/320px/320_maria_mao.png";
import ImgTeamCarlos320 from "../assets/images/320px/320_carlos_silvani.png";
import ImgTeamRomina320 from "../assets/images/320px/320_romina_fiorenza.png";
import ImgTeamAlejandroC320 from "../assets/images/320px/320_alejandro_cabaccheff.png";
import ImgTeamLeonardo320 from "../assets/images/320px/320_leonardo_bonomo.png";
import ImgTeamMrSong320 from "../assets/images/320px/320_mr_song.png";
import ImgTeamMrWu320 from "../assets/images/320px/320_mr_wu_mr_wang.png";
/*  */
import ImgTeamDavid768 from "../assets/images/768px/768_david_ding.png";
import ImgTeamUriel768 from "../assets/images/768px/768_uriel_natero.png";
import ImgTeamHumberto768 from "../assets/images/768px/768_humberto_bertazza.png";
import ImgTeamAlejandroO768 from "../assets/images/768px/768_alejandro_ottero.png";
import ImgTeamMaria768 from "../assets/images/768px/768_maria_mao.png";
import ImgTeamCarlos768 from "../assets/images/768px/768_carlos_silvani.png";
import ImgTeamRomina768 from "../assets/images/768px/768_romina_fiorenza.png";
import ImgTeamAlejandroC768 from "../assets/images/768px/768_alejandro_cabaccheff.png";
import ImgTeamLeonardo768 from "../assets/images/768px/768_leonardo_bonomo.png";
import ImgTeamMrSong768 from "../assets/images/768px/768_mr_song.png";
import ImgTeamMrWu768 from "../assets/images/768px/768_mr_wu_mr_wang.png";
/*  */
import ImgTeamDavid1440 from "../assets/images/1440px/1440_david_ding.png";
import ImgTeamUriel1440 from "../assets/images/1440px/1440_uriel_natero.png";
import ImgTeamHumberto1440 from "../assets/images/1440px/1440_humberto_bertazza.png";
import ImgTeamAlejandroO1440 from "../assets/images/1440px/1440_alejandro_ottero.png";
import ImgTeamMaria1440 from "../assets/images/1440px/1440_maria_mao.png";
import ImgTeamCarlos1440 from "../assets/images/1440px/1440_carlos_silvani.png";
import ImgTeamRomina1440 from "../assets/images/1440px/1440_romina_fiorenza.png";
import ImgTeamAlejandroC1440 from "../assets/images/1440px/1440_alejandro_cabaccheff.png";
import ImgTeamLeonardo1440 from "../assets/images/1440px/1440_leonardo_bonomo.png";
import ImgTeamMrSong1440 from "../assets/images/1440px/1440_mr_song.png";
import ImgTeamMrWu1440 from "../assets/images/1440px/1440_mr_wu_mr_wang.png";

import LogoFooter from "../assets/images/dings_logo_ingles.svg";
import LogoNavbar from "../assets/images/dings_logo_ingles.svg"
import Navbar from "./navbar/navbar";
import Accordeon from "./accordeon/accordeon";
import Carousel from "./carousel/carousel"
import BannerEn from './banneren/banner'
import "./en.css";

const Inicio = () => {
  const [width, setWidth] = useState(window.innerWidth);


  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    if (width < 1350){
      setIsOpen(!isOpen);
    }
  


  }
useEffect(()=>{ if (width > 768){
  setIsOpen(false);

}},[width])
   
  
  return (
    <>
      {/* Navbar */}
      <header>
      <nav>
          <div>
            <Link to="/en" class="enlace">
            
              <img className="logonav"
              src={LogoNavbar}
              />
            </Link>
          </div>
          <input checked  type="checkbox" id="check" style={{display
          :"none"}} />
        
          <ul  className={  isOpen ? 'ulnav' : 'hidden' }
 id="ulnav">
              <label onClick={toggleNavbar} class="checkbtn close" id="cerrar">
            <i  class="fa-solid fa-xmark"></i>
          </label>
            <li  onClick={toggleNavbar}><a  id="cerrarLink" for="check" href="#aboutus">About Us</a></li>

            <li onClick={toggleNavbar} ><a id="cerrarLink1" href="#services">Services</a></li>

            <li onClick={toggleNavbar} >
              <a id="cerrarLink2" href="#team">Team</a>
            </li>
            <li onClick={toggleNavbar} ><a id="cerrarLink3" href="#contact">Contact</a></li>
            <li className="listLenguage"><Link id="cerrarLink4" to="/en">EN</Link>|<Link to="/ch">中文</Link></li>
          </ul>
<button class="checkbtn" onClick={toggleNavbar}>
<i class="fas fa-bars"></i>
</button>
          
        </nav>
      </header>
      <BannerEn/>
      <section id="aboutus" className="banner">
        <div className="headerContainer">
          <div className="headerTextContainer">
            <Text value="Boots your business with" styleClass="textHeader" />
            <Title styleClass="titleHeader" value="Ding's Group Argentina" />
            <Text
              styleClass="textHeaderTwo"
              value="Consultancy combines local experience and international network to ensure professional"
            />
          </div>
          <div className="containerbuttonheader">
            <Link to="mailto:bocabeijing@gmail.com">  <Button styleClass="btnPrimary buttonHeader" value="CONTACT US" /></Link>
          </div>
        </div>
      </section>
      <main>
        <Carousel/>
        {/*  <div className="contentContainer"> */}
        {/* aboutus */}
        <div className="aboutUsContainer">
          <div className="aboutUs">
            <Title styleClass="titleAboutUs" value="About us" />
            <Text
              styleClass="textAboutUs"
              value="At Ding's Group, we're on a mission to build a better society by solving important problems and earning your trust. Our unwavering commitment to genuine leadership, innovation and excellence sets us apart in the industry. We strive to be your most trusted, reliable and relevant partner by delivering world-class services and making decisions that reflect our values. Join us in our quest to make a difference, and together let's build a better tomorrow"
            />
          </div>
          <div className="cards">
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsOne} />
              <div className="cardData">
                <Title styleClass="cardTitle" value="Ding´s Group" />
                <Text
                  styleClass="cardText"
                  value="Consultancy combines local experience and international network to ensure professional, efficient and high quality services for your enterprise. Over the years, we have carried out overseas business training and consulting work at different levels for ministries and enterprises such as the Ministry of Science and Technology, the State Administration of Taxation, the Ministry of Agriculture, the Ministry of Forestry, Bank of China, Industrial and Commercial Bank of China, Huawei, and Aerospace Industry Group."
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsTwo} />
              <div  className="cardData">
                <Title
                  styleClass="cardTitle"
                  value="Well-practiced Experience"
                />
                <Text
                  styleClass="cardText"
                  value="The industries we serve include electronics, mechanical equipment, metallurgy, chemical industry, transportation, e-commerce, consumer goods, catering, financial industry, service industry, etc. will keep generalizing experience and deliver professional solutions to you with business and industry knowledge."
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsThree} />
              <div  className="cardData">
                <Title styleClass="cardTitle" value="Professional Team" />
                <Text
                  styleClass="cardText"
                  value="We have an excellent professional team with many years of working experience, including certified public accountants, certified tax agents, enterprise architects, cost engineers and so on.
  They provide clients with a broad spectrum of professional services, such as financial
  and tax consulting, tax planning, international tax advisory, transfer pricing, finance
  & tax related risk control, enterprise management consulting. With rich resources
  and extensive practice, our professionals will help you to design practical solutions."
                />
              </div>
            </div>
          </div>
        </div>
        {/* OurServices */}
        <div id="services" className="services">
          <Title styleClass="servicesTitle" value="Our services" />
          <Text
            styleClass="servicesText"
            value="We provide clients with a broad spectrum of professional services, such as financial and tax consulting, tax planning, international tax advisory, transfer pricing, finance & tax related risk control, enterprise management consulting. With rich resources and extensive practice, our professionals will help you to design practical solutions."
          />
          <Accordeon />

          <div className="servicesCards"></div>
        </div>
        <div id="team" className="team">
          <div className="teamContentContainer">
            <Title styleClass="teamTitle" value="Team Members and Partners" />
            <Text
              styleClass="teamText"
              value="At our core, we're problem-solvers. Our team of seasoned professionals,  provide a diverse range of expert services, such as financial consulting, tax planning, and enterprise management. We believe that practical solutions are key, and with our extensive resources and expertise, we're equipped to help you tackle any challenge. Let's work together to unlock your enterprise's full potential."
            />
          </div>
          <div className="cardsTeam">
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
                {/*   <img className="imgTeam" src={ImgTeamDavid320} /> */}
                {/* 
              <img className="imgTeam" src={ImgTeamDavid768} />
              <img className="imgTeam" src={ImgTeamDavid1440} /> */}

                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamDavid320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamDavid768} />}
                {width > 1440 && <img src={ImgTeamDavid1440} />}

                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr.David Ding"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Professor of International Tax in Central University of Finance and Economics China (CUFE) and IEFPA Argentina"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
                {/*  <img className="imgTeam" src={ImgTeamUriel320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamUriel320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamUriel768} />}
                {width > 1440 && <img src={ImgTeamUriel1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamUriel768} />
              <img className="imgTeam" src={ImgTeamUriel1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Uriel Natero"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Argentina accountant"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
           {/*      <img className="imgTeam" src={ImgTeamHumberto320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamHumberto320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamHumberto768} />}
                {width > 1440 && <img src={ImgTeamHumberto1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamHumberto768} />
              <img className="imgTeam" src={ImgTeamHumberto1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Humberto Bertazza"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Argentina accountant"
                  />
                </div>
              </div>
            </div>

            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
          {/*       <img className="imgTeam" src={ImgTeamAlejandroO320} /> */}
          {width < 768 && (
                  <img className="imgTeam" src={ImgTeamAlejandroO320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamAlejandroO768} />}
                {width > 1440 && <img src={ImgTeamAlejandroO1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamAlejandroO768} />
              <img className="imgTeam" src={ImgTeamAlejandroO1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Alejandro Ottero"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Tax Officer
                Vicedecano de la Universidad Nacional de Moreno"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
               {/*  <img className="imgTeam" src={ImgTeamMaria320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMaria320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMaria768} />}
                {width > 1440 && <img src={ImgTeamMaria1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamMaria768} />
              <img className="imgTeam" src={ImgTeamMaria1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dra. Maria Mao"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Partner of PWC China"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
            {/*     <img className="imgTeam" src={ImgTeamCarlos320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamCarlos320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamCarlos768} />}
                {width > 1440 && <img src={ImgTeamCarlos1440} />}
                {/* 
              
              <img className="imgTeam" src={ImgTeamCarlos768} />
              <img className="imgTeam" src={ImgTeamCarlos1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Carlos Silvani"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Ex-Administrator of Taxation Authority"
                  />
                </div>
              </div>
            </div>
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
     {/*            <img className="imgTeam" src={ImgTeamRomina320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamRomina320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamRomina768} />}
                {width > 1440 && <img src={ImgTeamRomina1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamRomina768} />
              <img className="imgTeam" src={ImgTeamRomina1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Lic. Romina Fiorenza"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Public Administrator"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
                {/* <img className="imgTeam" src={ImgTeamAlejandroC320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamAlejandroC320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamAlejandroC768} />}
                {width > 1440 && <img src={ImgTeamAlejandroC1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamAlejandroC768} />
              <img className="imgTeam" src={ImgTeamAlejandroC1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Prof. Alejandro Cabaccheff"
                  />
                  <Text styleClass="cardsTeamText" value="Tax Officer" />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
             {/*    <img className="imgTeam" src={ImgTeamLeonardo320} /> */}
             {width < 768 && (
                  <img className="imgTeam" src={ImgTeamLeonardo320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamLeonardo768} />}
                {width > 1440 && <img src={ImgTeamLeonardo1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamLeonardo768} />
              <img className="imgTeam" src={ImgTeamLeonardo1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Lic. Leonardo Bonomo"
                  />
                  <Text styleClass="cardsTeamText" value="Lawyer" />
                </div>
              </div>
            </div>
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
               {/*  <img className="imgTeam" src={ImgTeamMrSong320} /> */}
               {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMrSong320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMrSong768} />}
                {width > 1440 && <img src={ImgTeamMrSong1440} />}
                {/*    <img className="imgTeam" src={ImgTeamMrSong768} />
              <img className="imgTeam" src={ImgTeamMrSong1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard styleClass="cardsTeamTitle" value="Mr. Song" />
                  <Text
                    styleClass="cardsTeamText"
                    value="President of China Tax Consulting Group"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
             {/*    <img className="imgTeam" src={ImgTeamMrWu320} /> */}
             {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMrWu320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMrWu768} />}
                {width > 1440 && <img src={ImgTeamMrWu1440} />}
                {/* <img className="imgTeam" src={ImgTeamMrWu768} />
              <img className="imgTeam" src={ImgTeamMrWu1440} /> */}

                <div className="cardsTeamContent">
                  <TitleCard styleClass="cardsTeamTitle" value="Mr. Wu" />
                  <Text
                    styleClass="cardsTeamText"
                    value="Ex Director General of Beijing Tax Administration China"
                  />
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Mr. WangYukuang"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Mr. Wang Yukuang.
              Ex Vice Director General of International Department of SAT China"
                  />
                </div>
              </div>
              <div className="teamDivider teamDividerEnd"></div>
            </div>
          </div>
        </div>
        {/*         </div> */}
        <div id="contact" className="contact">
          <h3 className="contactTitle">
            Unlock your enterprise's potential with our{" "}
            <span className="highlighter">top-tier consultancy</span>Our local
            experience and global network ensure.{" "}
            <span className="highlighter">
              efficient, high-quality services.
            </span>{" "}
            Let us help you soar with our proven track record of providing
            customized overseas business training and consulting.{" "}
            <span className="highlighter">Contact us to get started!</span>
          </h3>
          <Link to="mailto:bocabeijing@gmail.com">   <Button styleClass="btnPrimary" value="CONTACT US" /> </Link>
        </div>
        <footer>
          <div className="footerContainer">
            <img className="imgLogoFooter" src={LogoFooter} />
            <div className="footerContact">
            <div className="footercolumn">
            <Text value="Contact (Argentina)" styleClass="footerTitle" />
              <ul>
                <li>Tel: (+54 11) 53560941</li>
                <li>Mob: ( +54 9 11) 40566659</li>
                <ul className="emailList">
                  {" "}
                  Email: bocabeijing@gmail.com |<li>bocabeijing@qq.com</li>
                </ul>
                <li>Adress: Av. Alicia Moreau de Justo 1750, 1st floor B</li>
              </ul>
            </div>
            <div className="footercolumn"> 
            <Text value="Contact (China)" styleClass="footerTitle" />
              <ul>
                <li>Tel : ( +86) 010-63313490</li>
                <li>Mob : ( +86) 186-11536366</li>
              </ul>
            </div>
            </div>
          </div>
          <div className="copy">
            <p>
              Powered by <Link to="#"> Flipa© </Link> - All rights reserved.
            </p>
          </div>
        </footer>
      </main>
    </>
  );
};

export default Inicio;
